import React from 'react';

export default function ChannelCardLoader() {
  return (
    <div className='w-1/3 pr-6 pb-8 animate-pulse'>
      <div className='border border-gray border-opacity-10 rounded-2xl shadow-lg p-4 bg-white select-none'>
        <div className='flex justify-between items-center'>
          <div className='flex space-x-2 items-center'>
            <div className='w-12 h-12 rounded-full bg-slate-200'></div>
            <div className='w-40 h-7  rounded-md bg-slate-200'></div>
          </div>
          <div className='flex space-x-2 items-center'>
            <div className='w-3 h-5 bg-slate-200'></div>
          </div>
        </div>
        <div className='flex mt-4 items-center space-x-4'>
          <div>
            <div className='w-48 mb-4 h-5  rounded-md bg-slate-200'></div>
            <div className='w-48 h-5  rounded-md bg-slate-200'></div>
          </div>
          <div className='flex items-center'>
            <div className='w-12 h-12 border-white border-2 rounded-full bg-slate-200'></div>
            <div className='w-12 h-12 -ml-2 border-white border-2 rounded-full bg-slate-200'></div>
            <div className='w-12 h-12 -ml-2 border-white border-2 rounded-full bg-slate-200'></div>
          </div>
        </div>
        <div className='flex justify-between items-center mt-8'>
          <div className='flex space-x-2 items-center'>
            <div className='w-12 h-12 rounded-full bg-slate-200'></div>
            <div>
              <div className='w-28 h-5  mb-1 rounded-md bg-slate-200'></div>
              <div className='w-28 h-3  rounded-md bg-slate-200'></div>
            </div>
          </div>
          <div className='flex space-x-2 items-center'>
            <div className='w-20 rounded-md h-5 bg-slate-200'></div>
          </div>
        </div>
      </div>
    </div>
  );
}
